// extracted by mini-css-extract-plugin
export default {"paragraph":"paragraph-ui_paragraph__ia46D"};